import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'

function getMessage(field, args) {
  return `The ${field} cannot be earlier than From Date.`
}

function validate(value, args) {
  if (value) {
    if (args === void 0) args = []
    var startDate = args[0]
    if (startDate) {
      if (isAfter(removeTime(startDate), removeTime(value))) return false
      else return true
    } else return true
  } else return true
}

export default {
  getMessage,
  validate
}
